import React from "react";
import { Link } from "react-router-dom";
import PlatformShareButton from "./Buttons";
import UniversalShareActions from "./UniversalShareActions";
import { cdnImage } from "../lib/cdn";

const Card = ({ campaign, index = 0, track, dimmed = false }) => {
    const platforms = campaign.platforms || [];
    const delay = Math.min(index, 10) * 60;

    return (
        <article
            className={`card-enter break-inside-avoid mb-5 bg-white rounded-2xl shadow-brand overflow-hidden transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg ${
                dimmed ? "opacity-40 hover:opacity-100" : ""
            }`}
            style={{ animationDelay: `${delay}ms` }}
        >
            <Link
                to={`/share?ids=${campaign.id}`}
                className="block group"
            >
                <img
                    className="w-full h-auto block"
                    src={cdnImage(campaign.image_url, { width: 800 })}
                    alt=""
                    loading="lazy"
                />
                <div className="px-5 pt-5">
                    <h2 className="font-brand text-lg font-bold text-brand-ink leading-snug line-clamp-2 group-hover:text-brand-red transition-colors">
                        {campaign.title}
                    </h2>
                    <p className="mt-2 italic text-sm text-brand-muted leading-relaxed line-clamp-2">
                        {campaign.description}
                    </p>
                </div>
            </Link>
            <div className="px-5 pb-5 pt-4">
                {platforms.length > 0 && (
                    <div className="flex flex-wrap gap-2">
                        {platforms.map((platform) => (
                            <PlatformShareButton
                                key={platform}
                                platform={platform}
                                image_link={campaign.image_url}
                                description={campaign.description}
                                post_url={campaign.post_url}
                                post_id={campaign.id}
                                track={track}
                            />
                        ))}
                    </div>
                )}
                <UniversalShareActions
                    image_link={campaign.image_url}
                    description={campaign.description}
                    post_url={campaign.post_url}
                    post_id={campaign.id}
                    track={track}
                />
            </div>
        </article>
    );
};

export default Card;
